// removed by extract-text-webpack-plugin
module.exports = {"component":"Z-aTt-tlaFs0IRNn66Xv9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ThankYouPage/BoletoPage/BoletoProducer/boletoProducer.css
// module id = 1272
// module chunks = 2